import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { components } from '@atlaskit/select';
export var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);
  var _super = _createSuper(Input);
  function Input() {
    var _this;
    _classCallCheck(this, Input);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    // onKeyPress is used instead as
    // react-select is using onKeyDown for capturing keyboard input
    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      var _this$props$selectPro;
      if (e.key === 'Enter') {
        e.preventDefault();
      }
      //@ts-ignore react-select unsupported props
      if ((_this$props$selectPro = _this.props.selectProps) !== null && _this$props$selectPro !== void 0 && _this$props$selectPro.disableInput) {
        e.preventDefault();
      }
    });
    return _this;
  }
  _createClass(Input, [{
    key: "ariaLabelledBy",
    get:
    /**
     * Overrides the default behaviour of react-select lib
     *
     * The getter is a workaround for original behaviour of the react-select lib.
     * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
     * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
     * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
     */
    function get() {
      var _this$props$ariaLabe;
      return (_this$props$ariaLabe = this.props['aria-labelledby']) !== null && _this$props$ariaLabe !== void 0 ? _this$props$ariaLabe : this.props['aria-describedby'];
    }
  }, {
    key: "ariaDescribedBy",
    get: function get() {
      var _this$props$selectPro2, _this$props$selectPro3;
      return (_this$props$selectPro2 = (_this$props$selectPro3 = this.props.selectProps) === null || _this$props$selectPro3 === void 0 ? void 0 : _this$props$selectPro3['aria-describedby']) !== null && _this$props$selectPro2 !== void 0 ? _this$props$selectPro2 : this.props['aria-describedby'];
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(components.Input, _extends({}, this.props, {
        "aria-labelledby": this.ariaLabelledBy,
        "aria-describedby": this.ariaDescribedBy,
        innerRef: this.props.innerRef,
        onKeyPress: this.handleKeyPress
      }));
    }
  }]);
  return Input;
}(React.Component);